export default __webpack_public_path__ + "static/partner5-72c81fa96f6d93bdf59a1e877b033a2d.png";